/* eslint guard-for-in: 0 */
import clone from 'shallow-clone';
import typeOf from 'kind-of';
import * as urlParameterNames from '../consts/urlParameterNames';

function cloneDeep(val, instanceClone) {
  switch (typeOf(val)) {
    case 'object':
      return cloneObjectDeep(val, instanceClone);

    case 'array':
      return cloneArrayDeep(val, instanceClone);

    default:
      {
        return clone(val);
      }
  }
}

function cloneObjectDeep(val, instanceClone) {
  if (typeof instanceClone === 'function') {
    return instanceClone(val);
  }

  if (typeOf(val) === 'object') {
    var res = new val.constructor();

    for (var key in val) {
      res[key] = cloneDeep(val[key], instanceClone);
    }

    return res;
  }

  return val;
}

function cloneArrayDeep(val, instanceClone) {
  var res = new val.constructor(val.length);

  for (var i = 0; i < val.length; i++) {
    res[i] = cloneDeep(val[i], instanceClone);
  }

  return res;
}

function createParam(name, value) {
  return name + "=" + encodeURIComponent(value);
}

function isFindWebsiteDefaults(findWebsite) {
  return findWebsite && findWebsite.isNeedWebsite === true;
}

export function stateToUrlParams(logoState, debugApp, referralAdditionalInfo, referralInfo, additionalParams) {
  var arrParams = [];
  var result = '';

  if (logoState) {
    var companyDetails = logoState.companyDetails,
        industry = logoState.industry,
        tags = logoState.tags,
        logoId = logoState.logoId,
        prints = logoState.prints,
        findWebsite = logoState.findWebsite,
        selectedZoeTemplate = logoState.selectedZoeTemplate,
        selectedWebsiteId = logoState.selectedWebsiteId,
        designId = logoState.designId;

    if (companyDetails && !logoId && !designId) {
      var companyName = companyDetails.companyName,
          tagLine = companyDetails.tagLine;

      if (companyName) {
        arrParams.push(createParam('companyName', companyName));
      }

      if (tagLine) {
        arrParams.push(createParam('tagLine', tagLine));
      }
    }

    if (industry && industry.industry) {
      var industryValue = industry.industry,
          isCustom = industry.isCustom;
      arrParams.push(createParam('industry', JSON.stringify({
        industry: industryValue,
        isCustom: isCustom
      })));
    }

    if (tags && Array.isArray(tags) && tags.length) {
      arrParams.push(createParam('tags', tags.join(',')));
    }

    if (typeof selectedWebsiteId === 'number' && selectedWebsiteId > -1) {
      arrParams.push(createParam('selectedWebsiteId', selectedWebsiteId));
    }

    if (logoId) {
      arrParams.push(createParam('logoId', logoId));
    }

    if (designId) {
      arrParams.push(createParam('designId', designId));
    }

    if (prints) {
      var p = prints.p,
          printSuffix = prints.printSuffix;

      if (p) {
        arrParams.push(createParam('p', p));
      }

      if (printSuffix) {
        arrParams.push(createParam('printSuffix', printSuffix));
      }
    }

    if (findWebsite && !isFindWebsiteDefaults(findWebsite)) {
      arrParams.push(createParam('findWebsite', JSON.stringify(findWebsite)));
    }

    if (!logoId && !designId && selectedZoeTemplate) {
      var id = selectedZoeTemplate.id,
          iconId = selectedZoeTemplate.iconId,
          iconSource = selectedZoeTemplate.iconSource,
          iconUrl = selectedZoeTemplate.iconUrl,
          colorPaletteEntityId = selectedZoeTemplate.colorPaletteEntityId,
          designTemplate = selectedZoeTemplate.designTemplate;

      if (id) {
        arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_ID_PARAMETER_NAME, id));
      }

      if (iconId && iconSource) {
        arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_ICON_ID_PARAMETER_NAME, iconId));
        arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_ICON_SOURCE_PARAMETER_NAME, iconSource));
      } else if (iconUrl) {
        arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_ICON_URL_PARAMETER_NAME, iconUrl));
      }

      if (colorPaletteEntityId) {
        arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_COLOR_PALETTE_ENTITY_ID_PARAMETER_NAME, colorPaletteEntityId));
      }

      if (designTemplate && designTemplate.id) {
        arrParams.push(createParam(urlParameterNames.ZOE_DESIGN_TEMPLATE_ID_PARAMETER_NAME, designTemplate.id));
      }
    }
  }

  if (referralAdditionalInfo) {
    arrParams.push(createParam('referralAdditionalInfo', referralAdditionalInfo));
  }

  if (referralInfo) {
    arrParams.push(createParam('referralInfo', referralInfo));
  }

  if (debugApp) {
    arrParams.push(createParam('debugApp', debugApp));
  }

  if (additionalParams) {
    Object.keys(additionalParams).forEach(function (key) {
      arrParams.push(createParam(key, additionalParams[key]));
    });
  }

  if (arrParams.length) {
    result = "?" + arrParams.join('&');
  }

  return result;
}
export function zoeLogoToUrlParams(companyNameText, taglineText, logoId, options) {
  var debugApp = options.debugApp,
      referralAdditionalInfo = options.referralAdditionalInfo;
  var url = '';
  var arrParams = [];

  if (companyNameText) {
    arrParams.push(createParam('companyName', companyNameText));
  }

  if (taglineText) {
    arrParams.push(createParam('tagLine', taglineText));
  }

  if (logoId) {
    arrParams.push(createParam('logoId', logoId));
  }

  if (referralAdditionalInfo) {
    arrParams.push(createParam('referralAdditionalInfo', referralAdditionalInfo));
  }

  if (debugApp) {
    arrParams.push(createParam('debugApp', debugApp));
  }

  if (arrParams.length) {
    url = "?" + arrParams.join('&');
  }

  return url;
}